import AppLayout from '@/components/layout/AppLayout';
import ReconImport from '@/components/payments/ReconImport';

const Payments = () => {
  return (
    <AppLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Payments</h1>
          <p className="text-muted-foreground">
            Bank reconciliation and payment tracking
          </p>
        </div>

        <ReconImport />
      </div>
    </AppLayout>
  );
};

export default Payments;
